import { ensureJourneyDb, getById, listTable } from "../../db";
import { listAccessibleTransactions, resolveActor } from "./access";
import { hydrateTransaction } from "./helpers";

export function getBrokerOfficeSnapshot(session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  const brokerId = actor.isAdmin ? session?.brokerageId || actor.userId : actor.userId;
  const broker = getById("users", brokerId) || getById("users", actor.userId);
  const agents = listTable("users").filter((row) => {
    if (row.role_type !== "agent" || row.status === "inactive") return false;
    if (actor.isAdmin) return true;
    return row.brokerage_id === actor.userId;
  });
  const transactions = listAccessibleTransactions(session).map(hydrateTransaction);
  const open = transactions.filter((row) => row.status === "open");
  const archived = transactions.filter((row) => row.status !== "open");
  const now = Date.now();
  const monthAgo = now - 1000 * 60 * 60 * 24 * 30;
  const archivedThisPeriod = archived.filter((row) => {
    const at = Date.parse(row.closed_at || "");
    return Number.isFinite(at) && at >= monthAgo;
  });

  const brokerUserId = broker?.id || actor.userId;
  const mine = transactions.filter((row) => row.agent_id === brokerUserId);
  const office = transactions.filter((row) => row.agent_id !== brokerUserId);

  return {
    broker,
    brokerUserId,
    office_name: broker?.office_name || "",
    seat_tier: broker?.seat_tier || session?.seat_tier || "unlimited",
    plan_status: broker?.plan_status || session?.plan_status || "active",
    agents,
    transactions,
    mine,
    office,
    openCount: open.length,
    archivedCount: archived.length,
    archivedThisPeriod: archivedThisPeriod.length,
    mineOpen: mine.filter((row) => row.status === "open").length,
    officeOpen: office.filter((row) => row.status === "open").length,
  };
}
